import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { helpers } from './helpers';

const bannerAnim = (elem) => {
    const banner = document.querySelector('.banner');

    if (!banner) return;

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
    };

    let wasIntersecting = false;

    let observerCallback = (entries) => {
        let isIntersecting = entries.some((entry) => entry.isIntersecting);
        const questionsElements = document.querySelectorAll('#beacon-container, .language-switcher');

        if (isIntersecting && !wasIntersecting) {
            banner.classList.remove('banner--show');
            questionsElements.forEach((elem) => elem.classList.remove('floating-buy-button-active'));
        } else if (!isIntersecting && wasIntersecting) {
            banner.classList.add('banner--show');
            questionsElements.forEach((elem) => elem.classList.add('floating-buy-button-active'));
        }

        wasIntersecting = isIntersecting;
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    observer.observe(elem);

    // Handle facebook
    window.addEventListener('load', () => {
        if (window.App?.isFacebook && !banner.classList.contains('banner--facebook')) {
            banner.classList.add('banner--facebook');
        }
        if (window.App?.isInstagram && !banner.classList.contains('banner--instagram')) {
            banner.classList.add('banner--instagram');
        }
    });

    if (typeof Beacon === 'undefined' || !Beacon) return;

    Beacon('on', 'open', () => {
        if (!banner.classList.contains('banner--show')) return;

        document.getElementById('beacon-container').classList.add('floating-buy-button-active');
    });
};

const topBarAnim = () => {
    if (!window.App.isUpsell) return;

    const salesButton = document.querySelectorAll('.buy-button')[0];
    const topBar = document.getElementById('timer-top-banner');
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
    };

    let observerCallback = (entries) => {
        let isIntersecting = entries.some((entry) => entry.isIntersecting);

        if (isIntersecting) {
            topBar.classList.add('timer-top-banner--unfold');
            topBar.classList.remove('timer-top-banner--fold');
            observer.unobserve(salesButton);
        }
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    observer.observe(salesButton);
};

const parallaxAnim = () => {
    const parallaxItems = document.querySelectorAll('.parallax');
    const timelines = [];
    const resetTimelines = () => {
        ScrollTrigger.refresh();
    };

    parallaxItems.forEach((image) => {
        const nest = image.parentElement;
        const speed =
            helpers.isPhone() && helpers.isPortrait() ? image.dataset.speedMobile : image.dataset.speedDesktop;

        if (speed) {
            const tl = gsap.to(image, {
                yPercent: speed,
                ease: 'none',
                scrollTrigger: {
                    trigger: nest,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                },
            });

            timelines.push(tl);
        }
    });

    helpers.onOrientationChange(resetTimelines);
};

const appearAnim = () => {
    const elems = gsap.utils.toArray('.appear');

    elems.forEach((elem) => {
        gsap.from(elem, {
            y: helpers.isMobile() ? 60 : 30,
            ease: 'none',
            scrollTrigger: {
                trigger: elem,
                start: 'top bottom',
                end: '+=200',
                scrub: true,
            },
        });
    });
};

const summaryAnim = () => {
    const summaryAnimations = document.querySelectorAll('.summary__item');

    summaryAnimations.forEach((summary, i) => {
        if (i === 1) return;

        gsap.from(summary, {
            translateX: i === 0 ? '100%' : '-100%',
            ease: 'expo.out',
            scrollTrigger: {
                trigger: summary,
                start: 'top bottom',
                end: 'center center',
                scrub: true,
            },
        });
    });
};

const refreshAnim = () => {
    let refreshed = false;

    window.addEventListener('scroll', () => {
        if (window.scrollY > 53 && !refreshed) {
            refreshed = true;
            ScrollTrigger.refresh();
        }
    });
};

(function () {
    refreshAnim();
})();

export { bannerAnim, topBarAnim, parallaxAnim, appearAnim, summaryAnim };
